import React, { useState, useEffect, useRef, useContext } from "react";
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import LostDevicePage from './LostDevicePage';
import Playsound from '../components/Playsound';
import MlTimeoutPage from  './MlTimeoutPage';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Snackbar from "@material-ui/core/Snackbar";
import { DataContext } from "../data/DataContext";
import {
  ContentWrapper,
  SnackbarContent,
  PageTitle,
  SVGContainer,
  TTBody
} from "../styled-components/shared";
import './css/notification.css'
const StyledContentWrapper = styled(ContentWrapper)`
  padding: 10px;
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    textTransform: "none"
  },
  tabHeader:{
    border:"1px solid black",
    borderBbottom:"none",
    textTransform: "none"
  },
  borderLeftNone:{
    borderLeft:"none"
  }
}));

export default function Notifications() {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const serverResponse = useRef("");
  const { t } = useTranslation();
  // DLR flag
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext);
  const [showDLR, setShowDLR] = useState(false);
  const atRiskLabel = '"At-Risk" Device'

  const [tabList, setTabList] = useState([
    {
      label: atRiskLabel,
      element: (<MlTimeoutPage 
        serverResponse={serverResponse}
        setSnackbarOpen={setSnackbarOpen}
      />)
    },
    {
      label: t('playSoundNotification.lostDevices'),
      element: (<LostDevicePage 
        serverResponse={serverResponse}
        setSnackbarOpen={setSnackbarOpen}
      />)
    },
    {
      label: t('playSoundNotification.PlaySound'),
      element: (<Playsound 
        serverResponse={serverResponse}
        setSnackbarOpen={setSnackbarOpen}
      />)
    }
  ]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    if(!dlrFeatureFlag){
      // hiding At Risk if dlr feature is disabled
      setShowDLR(false);
    }
    else{
      if(mlPredictionStatus)  setShowDLR(true);     // showing At Risk if ml prediction enabled
      else  setShowDLR(false);                      // hiding At Risk if ml prediction disabled
    }
  }, [mlPredictionStatus, dlrFeatureFlag]);

  useEffect(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    if((urlParams.get("id") && urlParams.get("id") == "0")){
      setValue(0);
    }
  }, []);

  useEffect(() => {
    let tempTabList = [...tabList];
    if(!showDLR){
      if(tempTabList[0].label == atRiskLabel){
        tempTabList?.splice(0, 1);
      }
    }
    else{
      if(tempTabList[0].label != atRiskLabel){
        tempTabList?.unshift({
          label: atRiskLabel,
          element: (<MlTimeoutPage 
            serverResponse={serverResponse}
            setSnackbarOpen={setSnackbarOpen}
          />)
        })
      }
    }
    setTabList(tempTabList);
  }, [showDLR]);

  return (
    <StyledContentWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
        <PageTitle>{t('lostDeviceNearbyNotifications.Notifications')}</PageTitle>
        <div className={classes.root}>
        <Box borderBottom= {1} borderColor={'divider'} >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              centered
              fullWidth
            >
              {
                tabList.map((tList, index) => (
                  <Tab key={index} className={classes.tabHeader} label={tList.label} {...a11yProps(index)} />
                ))
              }
              <Tab disabled />
              <Tab disabled  />
              
            </Tabs>
          </Box>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            {
              tabList.map((tList, index) => (
                <TabPanel value={value} index={index} dir={theme.direction}>
                  { tList.element }
                </TabPanel>
              ))
            }
            
          </SwipeableViews>
        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => setSnackbarOpen(false)}
        >
          <SnackbarContent error={serverResponse.current.status ? false : true}>
            {serverResponse.current.msg}
          </SnackbarContent>
        </Snackbar>
    </StyledContentWrapper>
  );
}
